export const USER_DETAILS = "USER_DETAILS";

  export const addUser = (user) => ({
    type: "USER_DETAILS",
    payload:  user,
  });